(function () {
  'use strict';

  angular.module('app').component('creditNotesPage', CreditNotesPageComponent());

  function CreditNotesPageComponent() {
    return {
      bindings: {},
      controller: CreditNoteListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/credit-notes/credit-notes-page.component.html',
    };
  }

  CreditNoteListCtrl.$inject = ['$location', 'UtilService', 'AbilityService', 'CreditNoteService'];

  function CreditNoteListCtrl($location, UtilService, AbilityService, CreditNoteService) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = CreditNoteService.getFilterCriteria();

    vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(vm.UtilService.startOfMonth());
    vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

    vm.permissions = {
      canCreate: AbilityService.can('create_creditnote_accountadmin'),
    };

    // Methods
    vm.createCreditNote = createCreditNote;
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();

    function getItems() {
      vm.loadingItems = true;
      CreditNoteService.getCreditNotes(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createCreditNote() {
      $location.path('/credit_notes/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/credit_notes/${item.id}`).search({ mode: mode });
    }
  }
})();
